import {
  Divider,
  IconButton,
  InputAdornment,
  SvgIcon,
  TextField,
  Theme,
} from '@mui/material';
import { FC, useCallback } from 'react';
import { makeStyles } from 'tss-react/mui';
import { MdSearch as SearchIcon } from 'react-icons/md';
import { MdClose as CloseIcon } from 'react-icons/md';
import { FilterType } from '../../common/filters-utils/filters-utils';
import { important } from 'common-types';

const FilterSearch: FC<React.PropsWithChildren<FilterSearchProps>> = ({
  onSearch,
  filterType,
  searchValue,
}) => {
  const { classes } = useStyles();
  const handleChange = useCallback(
    event => {
      if (onSearch && filterType) {
        onSearch(event.target.value, filterType as FilterType);
      }
    },
    [filterType, onSearch],
  );
  const handleClear = () => {
    if (onSearch && filterType) {
      onSearch('', filterType);
    }
  };
  return (
    <div>
      <TextField
        className={classes.search}
        fullWidth
        variant='standard'
        placeholder='Search'
        size='small'
        type='text'
        value={searchValue}
        onChange={handleChange}
        InputProps={{
          style: { fontSize: '0.725rem' },
          disableUnderline: true,
          startAdornment: (
            <InputAdornment position='start'>
              <SvgIcon fontSize='small' color='action'>
                <SearchIcon />
              </SvgIcon>
            </InputAdornment>
          ),
          endAdornment: (
            <InputAdornment position='end'>
              <IconButton onClick={handleClear} disabled={!searchValue}>
                {<CloseIcon style={{ width: '0.8rem', height: '0.8rem' }} />}
              </IconButton>
            </InputAdornment>
          ),
        }}
      />
      <Divider />
    </div>
  );
};
const useStyles = makeStyles()((theme: Theme) => ({
  search: {
    padding: important(theme.spacing(1)),
  },
}));

export interface FilterSearchProps {
  onSearch?: (searchInput: string, filterType: string) => void;
  filterType?: string;
  searchValue?: string;
}

export default FilterSearch;
